const events = (
  state = {
    data: [],
    calendars: [],
  },
  action
) => {
  switch (action.type) {
    case "GET_ALL_EVENTS": {
      return { ...state, data: action.payload };
    }
    case "GET_ALL_CALENDARS": {
      const itemsToRemove = [
        "Feriados no Brasil",
        "Aniversários",
        "Holidays in Brazil",
      ];
      return {
        ...state,
        calendars: action.payload.filter(
          (item) => !itemsToRemove.includes(item.name)
        ),
      };
    }
    case "CREATE_EVENT": {
      return { ...state, eventCreate: action.payload };
    }
    case "UPDATE_EVENT": {
      return { ...state, eventUpdate: action.payload };
    }
    case "DELETE_EVENT": {
      return { ...state, eventDelete: action.payload };
    }
    default: {
      return state;
    }
  }
};

export default events;
